import { Fancybox } from '@fancyapps/ui';
export const funcyInit = () => {
    Fancybox.bind('[data-fancybox]', {});
};
